import app from '../app';
import Button from './Button';
import classList from '../utils/classList';
import Component from '../Component';
import Icon from './Icon';
export default class UploadImageButton extends Component {
  loading = false;
  view(vnode) {
    let {
      name,
      value,
      url,
      lockedBy,
      ...attrs
    } = vnode.attrs;
    attrs.loading = this.loading;
    attrs.className = classList(attrs.className, 'Button');
    if (typeof value === 'function') {
      value = value();
    }
    if (typeof url === 'function') {
      url = url();
    }
    if (lockedBy !== undefined) {
      return m("div", {
        className: "UploadImageButton UploadImageButton--locked"
      }, url ? m("div", {
        className: "UploadImageButton-image"
      }, m("img", {
        src: url,
        alt: name
      })) : null, m("p", {
        className: "UploadImageButton-lock helpText"
      }, m(Icon, {
        name: "fas fa-lock"
      }), ' ', lockedBy ? app.translator.trans('core.admin.upload_image.set_by_extension_text', {
        extension: lockedBy
      }) : app.translator.trans('core.admin.upload_image.set_in_code_text')));
    }
    return m("div", {
      className: "UploadImageButton"
    }, value ? m('[', null, m("div", {
      className: "UploadImageButton-image"
    }, m("img", {
      src: url,
      alt: name
    })), m(Button, Object.assign({
      onclick: this.remove.bind(this)
    }, attrs), app.translator.trans('core.admin.upload_image.remove_button'))) : m(Button, Object.assign({
      onclick: this.upload.bind(this)
    }, attrs), app.translator.trans('core.admin.upload_image.upload_button')));
  }
  upload() {
    if (this.loading) return;
    const $input = $('<input type="file">');
    $input.appendTo('body').hide().trigger('click').on('change', e => {
      const body = new FormData();
      // @ts-ignore
      body.append(this.attrs.name, $(e.target)[0].files[0]);
      this.loading = true;
      m.redraw();
      app.request({
        method: 'POST',
        url: this.resourceUrl(),
        serialize: raw => raw,
        body
      }).then(this.success.bind(this), this.failure.bind(this));
    });
  }
  remove() {
    this.loading = true;
    m.redraw();
    app.request({
      method: 'DELETE',
      url: this.resourceUrl()
    }).then(this.success.bind(this), this.failure.bind(this));
  }
  resourceUrl() {
    return app.forum.attribute('apiUrl') + '/' + this.attrs.routePath;
  }

  /**
   * After a successful upload/removal, reload the page.
   */
  success(response) {
    window.location.reload();
  }

  /**
   * If upload/removal fails, stop loading.
   */
  failure(response) {
    this.loading = false;
    m.redraw();
  }
}
flarum.reg.add('core', 'common/components/UploadImageButton', UploadImageButton);